module.exports = "<div id=\"howDoI-container\">\n  <div class=\"col-md-12 col-xs-12 widget navy-bg animated slideIn\">\n    <i class=\"fa fa-close pull-right\" ng-click=\"close()\"></i>\n    <div class=\"row\">\n      <iframe class=\"col-md-5\" width=\"520\" height=\"315\" src=\"{{video}}\" frameborder=\"0\" allowfullscreen></iframe>\n      <div class=\"col-md-7 col-xs-12\">\n        <h2>{{title}}</h2>\n        <br>\n        <p ng-bind-html=\"msg\"></p>\n      </div>\n    </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/howDoI/template.html
// module id = 1971
// module chunks = 0